import breakpoints from '../constants/breakpoints';
export default objWithBreakpointsAsKeys => Object.keys(breakpoints).filter(key => objWithBreakpointsAsKeys.hasOwnProperty(key));
//# sourceMappingURL=getSortedBreakpointKeys.js.map